function Tab(props) {
  let className =
    (props.className ?? "") +
    " tw-border-y tw-border-gray-medium tw-flex-auto tw-p-1 tw-font-condensed tw-font-black tw-text-lg md:tw-text-2xl tw-uppercase tw-italic hover:tw-bg-teal-light md:hover:tw-bg-teal hover:tw-border-teal-light hover:tw-text-white tw-transition-colors";
  if (props.active)
    className += " tw-bg-teal-dark tw-border-teal tw-text-white";

  return (
    <button onClick={props.onClick} className={className}>
      {props.label}
    </button>
  );
}

export default Tab;
